export default "__VITE_ASSET__THOb6SUG__"